var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor-content',{staticClass:"comment-editor custom_scrollbar",style:({ ..._vm.styles, height: _vm.height }),attrs:{"editor":_vm.editor},nativeOn:{"keyup":function($event){return _vm.handleSubmit.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }